// extracted by mini-css-extract-plugin
export default {"title":"Uaa-z","warning":"Vaa-z","sizeOptionsLegendText":"Waa-z"};